<template>
  <div class="sequenceDetailsDetails">
    <div class="tableCont">
      <Table size="small" :columns="columns" :dataSource="tableData" rowKey="id" :pagination="false">
      </Table>
    </div>
    <div class="footer">
      <div class="buttonCont">
        <Button size="large" @click="closeSequenceDetails">返回</Button>
      </div>
    </div>
  </div>
</template>

<script>
import { Table, Button } from 'ant-design-vue'
export default {
  props: {
    sequenceDetails: {
      type: String,
      default: ''
    }
  },
  components: {
    Table,
    Button
  },
  data () {
    return {
      columns: [
        { title: '序号', dataIndex: 'id', width: 50 },
        { title: '序列类别', dataIndex: 'sequence_category', width: 180 },
        { title: '序列名称', dataIndex: 'sequence_name', width: 200 },
        { title: '图片数量', dataIndex: 'size', width: 80 },
        { title: '接收时间', dataIndex: 'time', width: 200 },
      ],
      tableData: []
    }
  },
  mounted () {
    if (this.sequenceDetails) {
      let data = JSON.parse(this.sequenceDetails)
      data && data.image_list.forEach((val, index) => {
        this.tableData.push(
          Object.assign(val, { id: index + 1 })
        )
      })
    }
  },
  methods: {
    closeSequenceDetails () {
      this.$emit('closeSequenceDetails')
    }
  }
}
</script>

<style lang="less">
@import url('../../style/index.less');
.sequenceDetailsDetails{
  .tableCont{
    height: 240px;
    overflow-y: auto;
  }
  .footer{
    .modalFooter();
  }
}
</style>